import { fetchApi } from "../DataApi/fetchApi";
import { DB_NAME } from "../utilities/constants";

export async function webLoginApi(login, password, csrfToken) {
  const urlencoded = new URLSearchParams();
  urlencoded.append("csrf_token", csrfToken);
  urlencoded.append("login", login);
  urlencoded.append("password", password);
  urlencoded.append("db", DB_NAME);
  urlencoded.append("redirect", "/web");

  const requestOptions = {
    method: "POST",
    body: urlencoded,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    redirect: "follow",
    credentials: "include",
  };
  return fetchApi({
    requestOptions,
    endpoint: "/web/login",
    headers: {},
    checkSession: false,
  });
}
